<div class="company-register">
  <ng-container *ngIf="isFormView; else terms">
    <app-company-register-form2 [form]="formCompanyData" (emitter)="isFormView = false"></app-company-register-form2>
  </ng-container>
  <ng-template #terms>
    <app-company-register-form3 [form]="formAgreement" (backEmitter)="isFormView = true"
      (registerEmitter)="registerCompany()"></app-company-register-form3>
  </ng-template>
</div>